import { Controller } from "stimulus"
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = [ "input", "form" ]

  search() {
    event.preventDefault();
    event.stopPropagation();

    if (this.inputTarget.value == 'true') {
      this.inputTarget.value = 'false';
    } else {
      this.inputTarget.value = 'true';
    };

    Rails.fire(this.formTarget, 'submit');
  }
}
